import favicon from "../assets/branding/aafavicon.png";

export default function NotFoundPublic() {
  return (
    <div className="launch-root" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <div className="launch-hero-bg" aria-hidden="true" />

      <header className="launch-shell">
        <div className="launch-header">
          <a href="/hello" className="launch-logo" style={{ textDecoration: "none", color: "inherit" }}>
            <img className="launch-logo-mark" src={favicon} alt="ArtistAscend icon" />
            <span className="launch-logo-text">ArtistAscend</span>
          </a>
          <div className="launch-header-cta">
            <a className="launch-btn launch-btn--ghost" href="https://agents.artistascend.app/login">Sign In</a>
          </div>
        </div>
      </header>

      <main className="launch-shell" style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "80px 24px" }}>
        <div style={{ maxWidth: 480 }}>
          <h1 className="launch-display" style={{ fontSize: "clamp(2rem, 4vw, 3rem)", marginBottom: 16 }}>
            Page not found
          </h1>
          <p className="launch-lead" style={{ marginBottom: 28 }}>
            The page you&rsquo;re looking for doesn&rsquo;t exist or has been moved.
          </p>
          <a className="launch-btn" href="/hello">
            Back to homepage
          </a>
        </div>
      </main>

      <footer className="launch-shell launch-footer">
        <p className="launch-footer-note">&copy; 2026 ArtistAscend. All rights reserved.</p>
      </footer>
    </div>
  );
}
